import {createAction} from '@reduxjs/toolkit';

export const updateDecayDropdown = createAction('discreteDecay/updateDiscreteDecay');
